var _path, _path2, _path3, _path4, _path5;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgFileOutlined(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 21,
    viewBox: "0 0 22 21",
    fill: "current",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.62791 4C5.20406 4 4.86047 4.33579 4.86047 4.75C4.86047 5.16421 5.20406 5.5 5.62791 5.5H16.8837C17.3076 5.5 17.6512 5.16421 17.6512 4.75C17.6512 4.33579 17.3076 4 16.8837 4H5.62791Z",
    fill: "var(--primary-6)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.62791 8C5.20406 8 4.86047 8.33579 4.86047 8.75C4.86047 9.16421 5.20406 9.5 5.62791 9.5H7.67442C8.09826 9.5 8.44186 9.16421 8.44186 8.75C8.44186 8.33579 8.09826 8 7.67442 8H5.62791Z",
    fill: "var(--primary-6)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.7442 8C10.3203 8 9.97674 8.33579 9.97674 8.75C9.97674 9.16421 10.3203 9.5 10.7442 9.5H16.8837C17.3076 9.5 17.6512 9.16421 17.6512 8.75C17.6512 8.33579 17.3076 8 16.8837 8H10.7442Z",
    fill: "var(--primary-6)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M5.62791 12C5.20406 12 4.86047 12.3358 4.86047 12.75C4.86047 13.1642 5.20406 13.5 5.62791 13.5H16.8837C17.3076 13.5 17.6512 13.1642 17.6512 12.75C17.6512 12.3358 17.3076 12 16.8837 12H5.62791Z",
    fill: "var(--primary-6)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.83721 0C1.71798 0 0 1.67893 0 3.75V18.7901C0 20.0106 1.01243 21 2.26133 21C2.80113 21 3.32313 20.8113 3.73298 20.468L6.2603 18.3509C6.35261 18.2736 6.48786 18.2705 6.58383 18.3434L9.2724 20.387C10.2885 21.1594 11.7115 21.1594 12.7276 20.387L15.4162 18.3434C15.5121 18.2705 15.6474 18.2736 15.7397 18.3509L18.267 20.468C18.6769 20.8113 19.1989 21 19.7387 21C20.9876 21 22 20.0106 22 18.7901V3.75C22 1.67893 20.282 0 18.1628 0H3.83721ZM1.53488 3.75C1.53488 2.50736 2.56567 1.5 3.83721 1.5H18.1628C19.4343 1.5 20.4651 2.50736 20.4651 3.75V18.7901C20.4651 19.1822 20.1399 19.5 19.7387 19.5C19.5653 19.5 19.3976 19.4394 19.2659 19.3291L16.7386 17.2121C16.0924 16.6708 15.1456 16.6487 14.4738 17.1594L11.7853 19.203C11.3234 19.554 10.6766 19.554 10.2147 19.203L7.52616 17.1594C6.85436 16.6487 5.9076 16.6708 5.26141 17.2121L2.73409 19.3291C2.60243 19.4394 2.43474 19.5 2.26133 19.5C1.86012 19.5 1.53488 19.1822 1.53488 18.7901V3.75Z",
    fill: "var(--primary-6)"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileOutlined);
export default __webpack_public_path__ + "static/media/fileOutlined.7379f0c58e7a6192dfd5a1410fa44859.svg";
export { ForwardRef as ReactComponent };